import { sileo } from "sileo"
import { createElement } from "react"

const SuccessIcon = () =>
  createElement("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "#00FF7A", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" },
    createElement("path", { d: "M20 6L9 17l-5-5" })
  )

const ErrorIcon = () =>
  createElement("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "#ff4757", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" },
    createElement("circle", { cx: 12, cy: 12, r: 10 }),
    createElement("line", { x1: 15, y1: 9, x2: 9, y2: 15 }),
    createElement("line", { x1: 9, y1: 9, x2: 15, y2: 15 })
  )

const InfoIcon = () =>
  createElement("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "#00A8FF", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" },
    createElement("circle", { cx: 12, cy: 12, r: 10 }),
    createElement("line", { x1: 12, y1: 16, x2: 12, y2: 12 }),
    createElement("line", { x1: 12, y1: 8, x2: 12.01, y2: 8 })
  )

const WarningIcon = () =>
  createElement("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "#ffa502", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" },
    createElement("path", { d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" }),
    createElement("line", { x1: 12, y1: 9, x2: 12, y2: 13 }),
    createElement("line", { x1: 12, y1: 17, x2: 12.01, y2: 17 })
  )

export const toast = {
  success: (msg: string, _opts?: any) =>
    sileo.success({ title: msg, icon: createElement(SuccessIcon) }),

  error: (msg: string, _opts?: any) =>
    sileo.error({ title: msg, icon: createElement(ErrorIcon) }),

  info: (msg: string, _opts?: any) =>
    sileo.info({ title: msg, icon: createElement(InfoIcon) }),

  warning: (msg: string, _opts?: any) =>
    sileo.warning({ title: msg, icon: createElement(WarningIcon) }),

  promise: sileo.promise,
}

export const useToast = () => {
  return { toast }
}
